"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TimeInput = function TimeInput(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_.TextInput, _extends({}, props, {
    type: "time"
  }));
}; // TimeInput accepts all props that `TextInput` takes


var _default = TimeInput;
exports["default"] = _default;